const buildCollectionOverviewTitle = (name: string) => {
  const title = `${name} – Collection Overview`;

  return title;
};

export default buildCollectionOverviewTitle;
